import { useaxios } from "../../../utils/useaxios";
export default () => initDispatch => clear => settable_type => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    // initDispatch({ type: 'loadingTrue' });
    useaxios('report/company_loan/summary.php').then((res) => {
        if (res == "Unauthorized") {
            clear();
            return;
        } else if (res == "request_failed") {
            alert('no internet connection');
            return false;
        } else if (res.status == "ok") {
            if (res.data.length > 0) {
                initDispatch({ type: 'setsummary_loan_out_report', payload: res.data[0].total_loan });
            }
            settable_type("summary_loan_out_report");
        }
        // setloading(false);
    });
}